import Banner from './components/Banner';
import HomeBusiness from './components/HomeBusiness';
import HomeAboutUs from './components/HomeAboutUs';

const Home = () => (
  <div className="w-full">
    <div className="h-[100svh] min-h-[760px] min-w-[1480px]" data-home-banner-slot>
      <Banner />
    </div>
    <HomeAboutUs />
    <HomeBusiness />
  </div>
);

export default Home;
